(function(cny, $) {
    'use strict';
    cny.getDataTable = function(el) {
        $(el).DataTable({
            paging: false,
            language: {
                search: '',
            },
            dom:'fBiti',
            buttons:[
                {
                    extend:'csvHtml5',
                    text:'Export',
                    exportOptions: {
                        columns: ':not(.sorting_disabled)',
                    },
                },
            ],
        });
        $(el).each(function() {
            let datatable = $(this);
            let search_input = datatable.closest('.dataTables_wrapper').find('div[id$=_filter] input');

            search_input.removeClass('form-control-sm');

            $( "<strong>Search:</strong>" ).insertBefore( search_input );
        });
    };
    cny.filterGlobal = function(i, el, filter) {
        $(el).DataTable().column(i).search(
            $(`${filter}-${i}`).val()
        ).draw();
    };
    cny.filterColumnMenu = function(el, selectHtml, filter) {

        $(el).closest('.dataTables_wrapper').find('.dataTables_filter').append(selectHtml);

        $(filter).on( 'change', function () {
            cny.filterGlobal($(this).data('column'), el, filter);
        });
    }
})(window.cny = window.cny || {}, jQuery);



// WEBPACK FOOTER //
// ./scripts/routes/admin/partials/data-table.js